import "./style.css";
import LogoImage from "../../assets/images/login/logo.svg";
import React, {useRef, useState} from "react";
import {initialLoginDto, LoginDto} from "./dto/Login.dto";
import axios from "axios";
import * as APIUrl from "../../constants/ApiUrl";
import Popup from "../common/popup/Popup";
import {PopupProps} from "../common/popup/Popup.props";
import JSEncrypt from "jsencrypt";
import {useNavigate} from "react-router-dom";
import * as Routes from "../../constants/Routes";

export default function Login(props: any) {
    const inputRefs = useRef<any>([]);
    const [loginDto, setLoginDto] = useState<LoginDto>(initialLoginDto);
    const [popupProps, setPopupProps] = useState<PopupProps | null>(null);
    const [isVisibleErrorMessage, setIsVisibleErrorMessage] = useState<boolean>(false);
    const navigate = useNavigate();
    const {v4: uuid} = require('uuid');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = {
            ...loginDto,
            [event.target.name]: event.target.value
        }

        setLoginDto(value);
        setIsVisibleErrorMessage(false);
    }

    const handleEnterKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            checkValid();
        }
    }

    const checkValid = (): void => {
        if (loginDto.id === "") {
            inputRefs.current[0].focus();
            return;
        }

        if (loginDto.password === "") {
            inputRefs.current[1].focus();
            return;
        }

        getPublicKey();
    }

    const getPublicKey = (): void => {
        axios.get(APIUrl.PUBLIC_KEY).then(
            response => {
                const encrypt = new JSEncrypt();
                encrypt.setPublicKey(response.data);

                const encrypted = encrypt.encrypt(loginDto.password);

                if (encrypted === false) {
                    showPopup();
                } else {
                    let encryptedLoginDto = {
                        id: loginDto.id,
                        password: encrypted
                    }

                    requestAuth(encryptedLoginDto);
                }
            }
        ).catch(
            error => {
                showPopup();
            }
        );
    }

    const requestAuth = (request: LoginDto): void => {
        axios.post(APIUrl.LOGIN, request).then(
            () => {
                const expireDate = new Date(Date.now() + 1000 * 60 * 60 * 8);
                expireDate.setSeconds(0);
                expireDate.setMilliseconds(0);

                props.onCreateCookie("admin_token", uuid(), {
                    expires: new Date(expireDate)
                });

                navigate(Routes.NOTICE);
            }
        ).catch(
            error => {
                if (error.response.status === 400) {
                    setIsVisibleErrorMessage(true);
                } else {
                    showPopup();
                }
            }
        );
    }

    const showPopup = (): void => {
        setPopupProps({
            subject: "서버 오류",
            message1: "서버에 문제가 생겼습니다. 잠시 후 다시 시도해주세요",
            message2: null,
            buttonName: "확인",
            onConfirm: () => setPopupProps(null),
            useCloseButton: false,
            onClose: () => {}
        });
    }

    return (
        <>
            <div className="login-page">
                <div className="wrapper">
                    <div className="login-logo">
                        <img src={LogoImage} alt="dfos"/>
                    </div>
                    <div className={"login-input-wrapper " + (isVisibleErrorMessage ? "login-error" : "")}>
                        <div className="title">
                        <span>
                            아이디
                        </span>
                            <div className="err-msg">
                                {isVisibleErrorMessage && "아이디 또는 비밀번호를 확인해주세요."}
                            </div>
                        </div>
                        <input
                            ref={el => (inputRefs.current[0] = el)}
                            onChange={handleChange}
                            onKeyUp={handleEnterKey}
                            placeholder="아이디 입력"
                            name="id"
                        />
                    </div>
                    <div className="login-input-wrapper">
                        <div className="title">
                            <span>
                                비밀번호
                            </span>
                        </div>
                        <input
                            ref={el => (inputRefs.current[1] = el)}
                            onChange={handleChange}
                            onKeyUp={handleEnterKey}
                            placeholder="비밀번호 입력"
                            type="password"
                            name="password"
                        />
                    </div>
                    <button onClick={() => checkValid()} className="login-button">
                        로그인
                    </button>
                </div>
            </div>
            {
                popupProps && (
                    <Popup data={popupProps}/>
                )
            }
        </>
    );
}